module.exports = __webpack_public_path__ + "static/media/logo-gabarito.fa097e57.png";